import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuItem, MenuItemTypes } from '../head-menu.models';
import { HeadMenuService } from '../head-menu.service';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { AppStateService } from 'src/app/store/app-state-service';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { PendingApprovalsV2Service } from '../../../pending-approvals-v2/pending-approvals-v2.service';
import { ProcedureReport } from '../../../procedure/models/procedure-report.model';

@Component({
  selector: 'head-menu-mobile',
  templateUrl: './head-menu-mobile.component.html',
  styleUrls: ['./head-menu-mobile.component.scss']
})
export class HeadMenuMobileComponent implements OnInit, OnDestroy {

  currentUser!: User | null;

  menuItems: MenuItem[] = [];
  menuItems$!: Observable<MenuItem[]>;
  subscription: Subscription = new Subscription;

  isLoading = true;
  menuItemTypes = MenuItemTypes;
  unsubs: Subscription;

  pendingApprovals?: number;
  myPendingChanges?: number;

  trainingNotifications = 0;
  missingTrainings$!: Observable<ProcedureReport[]>;
  missingTrainingsSubs!: Subscription;

  constructor(
    private _service: HeadMenuService,
    private store: Store,
    private ass: AppStateService,
    public pendingApprovalsService: PendingApprovalsV2Service
  ) {
    this.unsubs = this.ass.AppState.subscribe(appState => {
      this.currentUser = appState.currentUser;
      this.load();
    });
    this.pendingApprovalsService.pendingApprovalsSubject.subscribe(data => {
      this.load();
    });
  }

  load() {
    this.loadMenuItems();
    this.pendingApprovals = this.pendingApprovalsService.pendingApprovals?.total;
    this.myPendingChanges = this.pendingApprovalsService.myPendingChanges?.total;
  }

  ngOnDestroy(): void {
    this.unsubs.unsubscribe();
    this.subscription.unsubscribe();
    this.missingTrainingsSubs?.unsubscribe();
  }

  ngOnInit() {
    this.loadMenuItems();
    this.loadMissingTrainings();
  }

  loadMissingTrainings() {
    this.missingTrainings$ = this.store.select(state => state.MissingTraining.data);
    this.missingTrainingsSubs = this.missingTrainings$.subscribe(data => {
      this.trainingNotifications = data.length;
    });
  }

  loadMenuItems() {
    this.menuItems$ = this.store.select(state => state.MenuItem.data);
    this.subscription = this.menuItems$.subscribe(data => {
      if (data.length) {
        const menuItems = this._service.calculateRouterLinks(data.filter((x: MenuItem) => !x.parentMenuItemID));
        this.menuItems = menuItems.sort((a, b) => a.order - b.order);
        this.isLoading = false;
      }
    });
  }

  notificationCount() {
    return (this.pendingApprovals ?? 0) + (this.myPendingChanges ?? 0);
  }

  hasNotifications() {
    return this.notificationCount() + this.trainingNotifications > 0;
  }

  openComponent(name: string) {
    this._service.openComponent(name);
  }

}
